import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Header } from "@perxis-auto/ui-kit/lib/components/Header";
import clsx from "clsx";
import { Skeleton } from "./skeleton/Skeleton.js";
import styles from "./VehicleHeader.module.scss.js";
const VehicleHeader = memo(function VehicleHeader2({
  t,
  title,
  description,
  status,
  showTitle,
  markers,
  onBackClick,
  isTagsEnable,
  className,
  isLoading = false,
  ...props
}) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { showTitle });
  }
  const hasCarInfo = showTitle && !!title;
  const hasStatus = isTagsEnable && !!status;
  const hasMarkers = !isTagsEnable && !!(markers == null ? void 0 : markers.length);
  return /* @__PURE__ */ jsx(Header, { className: clsx(styles.vehicleHeader, className), ...props, children: /* @__PURE__ */ jsxs(Row, { align: "middle", gutter: [24, "vertical-sky"], children: [
    /* @__PURE__ */ jsx(Col, { xs: { span: 12, order: 1 }, sm: { span: 12, order: 1 }, md: { span: hasCarInfo ? 6 : 12, order: 1 }, children: /* @__PURE__ */ jsx(Row, { justify: "start", children: /* @__PURE__ */ jsx(Header.BackButton, { label: t("widgets.vehicleHeader.backLabel"), onClick: onBackClick }) }) }),
    hasCarInfo && /* @__PURE__ */ jsx(Col, { xs: { span: 24, order: 3 }, sm: { span: 24, order: 3 }, md: { span: 12, order: 2 }, children: /* @__PURE__ */ jsx(Row, { justify: "center", children: /* @__PURE__ */ jsx(Header.CarInfo, { title, description }) }) }),
    /* @__PURE__ */ jsx(
      Col,
      {
        xs: { span: 12, order: 2 },
        sm: { span: 12, order: 2 },
        md: { span: hasCarInfo ? 6 : 12, order: hasCarInfo ? 3 : 2 },
        children: /* @__PURE__ */ jsxs(Row, { justify: "end", children: [
          hasMarkers && /* @__PURE__ */ jsx(Header.Markers, { markers }),
          hasStatus && /* @__PURE__ */ jsx(Header.Status, { ...status })
        ] })
      }
    )
  ] }) });
});
export {
  VehicleHeader
};
